import { queryClient } from "@impero-com/common/utils/query_client";

import { useDeleteTagsTagId } from "api/generated/tags/tags";

import { TAGS_QUERY_KEY } from "./useTagsQuery";

export const useDeleteTagMutation = () =>
    useDeleteTagsTagId({
        mutation: {
            onSuccess: () =>
                queryClient.invalidateQueries({ queryKey: TAGS_QUERY_KEY }),
        },
    });
